<template lang="html">
  <div :class="['page', {}]" id="overlay">
    <div class="content">
      <img :src="logoUrl" alt=""/>
      <h2>Estamos carregando o seu espaço...</h2>
      <half-circle-spinner :animation-duration="1500" :size="100" color="#609DE6"/>
        <h4>Aqui você poderá fazer uma previsão de sua mensalidade.</h4>
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  name: 'splash',
  data () {
    return {
    }
  },
  beforeMount () {
  },
  computed: {
    logoUrl () {
      return this.$api('logomarca')
    }
  },
  mounted () {},
  methods: {
  },
  components: {
    HalfCircleSpinner
  }
}
</script>
<style lang="scss" type="text/css" media="screen"></style>
